import React from "react";
import { Phone, AlertCircle } from "lucide-react";
import { Container, Button } from "@/components/primitives";
import { Reveal } from "@/components/Reveal";
import { PageHero, FaqSection, CTASection } from "@/components/sections";
import { useBooking } from "@/lib/booking";
import { useSeo } from "@/lib/seo";
import { business } from "@/data/site";

export default function Faq() {
  const { openBooking } = useBooking();
  useSeo({
    title: "Dental FAQ & Emergency Care | Meridian Dental Studio, Hell's Kitchen NYC",
    description: "Answers about insurance, emergency dental care, financing, comfort options and sterilization at Meridian Dental Studio in Hell's Kitchen, Manhattan. Same-day emergencies welcome.",
    path: "/faq",
  });

  return (
    <>
      <PageHero
        eyebrow="FAQ & Emergency Care"
        title="Everything you might want to ask."
        intro="Still curious after reading? Call or text us — real humans answer, and we're happy to help."
      />

      <section className="pb-4">
        <Container>
          <Reveal>
            <div className="flex flex-col items-start gap-6 rounded-2xl border border-[var(--primary)]/30 bg-[var(--primary)]/5 p-8 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-start gap-4">
                <AlertCircle size={26} className="mt-1 shrink-0 text-[var(--primary)]" />
                <div>
                  <h2 className="font-heading text-2xl font-normal text-[var(--fg)]">Emergency dental care in NYC</h2>
                  <p className="mt-2 max-w-xl text-sm leading-relaxed text-[var(--fg)]/80">
                    Broken tooth, severe pain, swelling or a lost crown? We reserve same-day emergency appointments every weekday. Call us now and tell us it's urgent — we'll prioritize you.
                  </p>
                </div>
              </div>
              <Button size="lg" href={business.phoneHref} className="shrink-0" data-testid="faq-emergency-call">
                <Phone size={16} /> {business.phoneDisplay}
              </Button>
            </div>
          </Reveal>
        </Container>
      </section>

      <FaqSection title="Frequently asked questions." eyebrow="Answers" />
      <CTASection eyebrow="Didn't find your answer?" title="We're a call or text away." />
    </>
  );
}
